(() => {
  const root = document.querySelector('[data-gp-split-editorial]');
  if (!root) return;

  const article = root.querySelector('[data-gp-article]');
  const bar = root.querySelector('[data-gp-progress]');
  const toc = root.querySelector('[data-gp-toc]');
  const tocList = toc ? toc.querySelector('ol') : null;
  const headings = article ? [...article.querySelectorAll('.gp-se-copy h2')] : [];
  const links = [];

  headings.forEach((heading, index) => {
    if (!heading.id) {
      heading.id = heading.textContent
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-') || `section-${index + 1}`;
    }

    if (tocList) {
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      li.appendChild(link);
      tocList.appendChild(li);
      links.push(link);
    }
  });

  if (toc && headings.length < 2) toc.hidden = true;

  const updateProgress = () => {
    if (!article || !bar) return;
    const rect = article.getBoundingClientRect();
    const start = window.scrollY + rect.top;
    const distance = Math.max(article.offsetHeight - window.innerHeight, 1);
    const value = Math.min(Math.max((window.scrollY - start) / distance, 0), 1);
    bar.style.width = `${value * 100}%`;
  };

  if ('IntersectionObserver' in window && headings.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        links.forEach((link) => link.classList.remove('is-active'));
        const active = links.find((link) => link.hash === `#${entry.target.id}`);
        if (active) active.classList.add('is-active');
      });
    }, { rootMargin: '-20% 0px -65% 0px' });

    headings.forEach((heading) => observer.observe(heading));
  }

  updateProgress();
  window.addEventListener('scroll', updateProgress, { passive: true });
  window.addEventListener('resize', updateProgress);
})();
